export default function enumerable(classProto: any, propertyKey: string, propertyDescriptor: PropertyDescriptor) {
    propertyDescriptor.enumerable = true;
}
